import { render } from "./MobileSubmit.vue?vue&type=template&id=56c895d1"
import script from "./MobileSubmit.vue?vue&type=script&lang=js"
export * from "./MobileSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__